import type { PropsWithChildren } from "react";

import { styled } from "styled-components";

import { Stack } from "@similarweb/ui-components/foundations";

const ResponsiveContainer = styled(Stack)`
    padding: 24px 44px 32px 44px;
    min-height: fit-content;

    @media (min-width: 1920px) {
        padding: 24px 120px 32px 120px;
    }
`;

export const NarrowContainer = ({ children }: PropsWithChildren) => (
    <ResponsiveContainer
        gap="32px"
        flex={1}
        minWidth={0}
    >
        {children}
    </ResponsiveContainer>
);
